module.exports = [
    { text: "Male", key: "male" },
    { text: "Female", key: "female" }]